import React from "react";
import "./Terms.css";
import logo from "../../../assets/images/logo.png";
import { FaAngleLeft } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

function Privacypolicy() {
  const style = { color: "white", fontSize: "15px" };
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackClick = () => {
    const from = location.state?.from || "/register";
    const formData = location.state?.formData || {};
    navigate(from, { state: { formData } });
  };

  return (
    <div className="body-terms">
      <div id="return-button">
        <FaAngleLeft style={style} />
        <a onClick={handleBackClick} style={{ cursor: "pointer" }}>
          Kthehu
        </a>
      </div>
      <div className="content">
        <div className="body-header">
          <h1>Brieffo</h1>
          <p>Politika e Privatësisë</p>
        </div>
        <div className="text">
          <div>
            <h1>Hyrje</h1>
            <p>
              Mirë se vini në Brieffo! Kjo Politikë Privatësie është krijuar për
              t'ju ndihmuar të kuptoni se si mbledhim, përdorim, zbulojmë dhe
              mbrojmë informacionin tuaj personal. Duke përdorur aplikacionin
              tonë, ju pranoni kushtet e përcaktuara në këtë politikë.
            </p>
          </div>
          <br />

          <div>
            <h1>Informacioni që Mbledhim</h1>
            <p>
              Ne mbledhim informacionin e mëposhtëm: <br />- Email dhe Emër: Ne
              mbledhim adresën tuaj të email-it dhe emrin kur krijoni një
              llogari për t'ju mundësuar të ruani lajmet tuaja të preferuara.
            </p>
          </div>
          <br />

          <div>
            <h1>Si Përdorim Informacionin Tuaj</h1>
            <p>
              Ne përdorim informacionin e mbledhur për qëllimet e mëposhtme:
              <br />
              - Personalizimi: Për të personalizuar përvojën tuaj dhe për të
              ofruar përmbajtje të përshtatur sipas preferencave tuaja.
              <br />
              - Menaxhimi i Llogarisë: Për të menaxhuar llogarinë tuaj, duke
              përfshirë mundësinë për të ruajtur dhe aksesuar lajmet tuaja të
              preferuara.
              <br />- Komunikimi: Për t'ju dërguar përditësime, njoftime dhe
              informacion tjetër lidhur me aplikacionin.
            </p>
          </div>
          <br />

          <div>
            <h1>Siguria e të Dhënave</h1>
            <p>
              Ne i japim prioritet sigurisë së informacionit tuaj dhe marrim
              masa të përshtatshme për ta mbrojtur atë.
            </p>
          </div>
          <br />

          <div>
            <h1>Zbulimi i Informacionit</h1>
            <p>
              Ne nuk shesim, tregtojmë ose transferojmë informacionin tuaj
              personal të identifikueshëm tek palët e treta. Megjithatë, mund të
              ndajmë informacion të përmbledhur, jo-personal me palë të treta
              për qëllime statistike.
            </p>
          </div>
          <br />

          <div>
            <h1>Zgjedhjet Tuaja</h1>
            <p>
              Ju mund të menaxhoni informacionin tuaj përmes cilësimeve të
              aplikacionit. Ju keni të drejtën të aksesoni, të korrigjoni ose të
              fshini informacionin tuaj personal. Nëse keni ndonjë shqetësim ose
              kërkesë në lidhje me të dhënat tuaja, ju lutemi kontaktoni në{" "}
              <a href="mailto:onlinekosova@gmail.com">onlinekosova@gmail.com</a>
            </p>
          </div>
          <br />

          <div>
            <h1>Privatësia e Fëmijëve</h1>
            <p>
              Aplikacioni ynë nuk është i destinuar për fëmijë nën moshën 13
              vjeç. Ne nuk mbledhim ose kërkojmë me qëllim informacion personal
              nga fëmijët. Nëse jeni prind ose kujdestar dhe besoni se fëmija
              juaj na ka dhënë informacion personale, ju lutemi kontaktoni me
              ne.
            </p>
          </div>
          <br />

          <div>
            <h1>Ndryshimet në këtë Politikë Privatësie</h1>
            <p>
              Ne rezervojmë të drejtën të përditësojmë Politikën tonë të
              Privatësisë në çdo kohë. Ju do të njoftoheni për çdo ndryshim duke
              postuar Politikën e Privatësisë së re në këtë faqe.
            </p>
          </div>
          <br />

          <div>
            <h1>Na Kontaktoni</h1>
            <p>
              Nëse keni ndonjë pyetje ose shqetësim në lidhje me këtë Politikë
              Privatësie, ju lutemi kontaktoni në{" "}
              <a href="mailto:onlinekosova@gmail.com">onlinekosova@gmail.com</a>
            </p>
          </div>
        </div>
        <div className="updated-text">
          <p>Përditësimi i fundit: 15.11.2023</p>
        </div>
      </div>
    </div>
  );
}

export default Privacypolicy;
